<template>
    <div class="d-flex align-center">
        <v-checkbox
            v-if="compareMode && !room.soldOut"
            v-model="compareOfferKeys"
            density="compact"
            :ripple="false"
            hide-details
            class="mb-1 me-1 ms-n1"
            :value="room.groupedOffers[0].offerKey"
            @click.stop
        />
        <slot />
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelRoomNameLabel extends Vue {
        @Prop({default: false, type: Boolean}) compareMode
        @Prop({required: true}) hotel
        @Prop({required: true}) room

        get compareOfferKeys() {
            return hotelsStore.offersToCompare.find(hotel => hotel.hotelCode === this.hotel.hotelCode)?.rooms || []
        }

        set compareOfferKeys(rooms) {
            hotelsStore.ADD_ROOM_TO_COMPARE({hotelCode: this.hotel.hotelCode, rooms})
        }
    }

    export default HotelRoomNameLabel
</script>
